import React from 'react';
import { Card } from '@mui/material';

interface PromoCardProps {
  onLearnMore: () => void;
  onStartForFree: () => void;
}

const PromoCard: React.FC<PromoCardProps> = ({ onLearnMore, onStartForFree }) => {
  return (
    <Card
      className="relative overflow-hidden"
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #3B82F6',
        borderRadius: '10px',
        boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        padding: '20px',
        position: 'relative',
        margin: '8px 0',
      }}
    >
      {/* Subtle blue gradient in top-left corner */}
      <div
        className="absolute top-0 left-0 pointer-events-none"
        style={{
          width: '120px',
          height: '120px',
          background: 'radial-gradient(circle at top left, rgba(59, 130, 246, 0.08) 0%, transparent 70%)',
        }}
      />

      <div className="flex items-start gap-4 mb-3">
        {/* Mobile phone with play icon SVG */}
        <div className="flex-shrink-0">
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Mobile phone outline */}
            <rect
              x="14"
              y="6"
              width="20"
              height="36"
              rx="2"
              stroke="#3B82F6"
              strokeWidth="2"
              fill="white"
            />
            {/* Screen */}
            <rect
              x="16"
              y="10"
              width="16"
              height="24"
              rx="1"
              fill="#EFF6FF"
            />
            {/* Play button */}
            <circle
              cx="24"
              cy="22"
              r="6"
              fill="#3B82F6"
            />
            <path
              d="M22.5 19.5 L28 22 L22.5 24.5 Z"
              fill="white"
            />
            {/* Home button */}
            <circle
              cx="24"
              cy="38"
              r="1.5"
              fill="#9CA3AF"
            />
          </svg>
        </div>

        <div className="flex-1">
          {/* Optional small label */}
          <div
            className="inline-block mb-2"
            style={{
              fontSize: '10px',
              fontWeight: '600',
              letterSpacing: '0.05em',
              color: '#3B82F6',
              textTransform: 'uppercase',
            }}
          >
            TRY SCOREBUZZER
          </div>

          {/* Headline */}
          <h3
            className="font-bold tracking-wide"
            style={{
              fontSize: '16px',
              background: 'linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              lineHeight: '1.4',
            }}
          >
            PLAY. SCORE. STREAM. SHARE.
          </h3>
        </div>
      </div>

      {/* Body text */}
      <p
        className="mb-4"
        style={{
          fontSize: '14px',
          color: '#374151',
          lineHeight: '1.5',
        }}
      >
        From social matches to national championships-score and live-stream directly to YouTube with score overlays. No laptops. No complicated setup.
      </p>

      {/* Buttons */}
      <div className="flex flex-col sm:flex-row gap-2.5">
        <button
          onClick={onLearnMore}
          className="flex-1 px-5 py-3 rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
          style={{
            background: '#FFFFFF',
            border: '1px solid #3B82F6',
            color: '#3B82F6',
            minHeight: '44px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#EFF6FF';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#FFFFFF';
          }}
        >
          Learn More
        </button>

        <button
          onClick={onStartForFree}
          className="flex-1 px-5 py-3 rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
          style={{
            background: '#3B82F6',
            color: '#FFFFFF',
            border: 'none',
            minHeight: '44px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#2563EB';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#3B82F6';
          }}
        >
          Start for Free
        </button>
      </div>
    </Card>
  );
};

export default PromoCard;
